import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {adminContractListAPI} from "../../../../services/admin";
import styles from "../account/AdminClient.module.css";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/24/outline";
import AdminContractInfo from "./AdminContractInfo";

interface AdminContractProps {
    contractId: number;
}

//계약 상세 페이지 버튼
const AdminContract: React.FC<AdminContractProps> = ({contractId}) => {
    const navigate = useNavigate();
    const [contractIds, setContractIds] = useState<number[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
        const fetchContracts = async () => {
            try {
                //계약 식별자 목록 API
                const response = await adminContractListAPI();
                setContractIds(response);
                const index = response.findIndex(cid => cid === contractId);
                setCurrentIndex(index);
            } catch (error) {
                console.error('Error fetching contracts:', error);
            }
        };
        fetchContracts();
    }, [contractId]);

    //이전 계약 페이지
    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevContractId = contractIds[currentIndex - 1];
            navigate(`/admin/clients/contract/${prevContractId}`);
        }
    };

    //다음 계약 페이지
    const handleNext = () => {
        if (currentIndex < contractIds.length - 1) {
            const nextContractId = contractIds[currentIndex + 1];
            navigate(`/admin/clients/contract/${nextContractId}`);
        }
    };

    //계약 식별자가 없을 경우
    if (!contractId) {
        return <div>Invalid contract ID</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.navigationContainer}>
                {/*다음 계약 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === 0 ? styles.disabled : ''}`}
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                    aria-label="Previous client"
                >
                    <ChevronLeftIcon className={styles.navIcon}/>
                </button>

                <div className={styles.contentWrapper}>
                    {/*계약 정보*/}
                    <AdminContractInfo contractId={contractId}/>
                </div>

                {/*이전 계약 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === contractIds.length - 1 ? styles.disabled : ''}`}
                    onClick={handleNext}
                    disabled={currentIndex === contractIds.length - 1}
                    aria-label="Next client"
                >
                    <ChevronRightIcon className={styles.navIcon}/>
                </button>
            </div>
        </div>
    );
};
export default AdminContract;